import Vue from 'vue'
import App from './App'
import router from './router'
import vant from 'vant'
// import WebIM from './utils/WebIM'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'vant/lib/icon/index.css'
import { mixinMessage, PreviewImage } from '@/utils/tool'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Antd)
Vue.use(ElementUI).use(vant)

// 暴露全局jquery
require('expose-loader?$!jquery')

// 引入自定义样式  以及js方法
import './assets/css/CommonStyle.css'
import CommonUtil from './assets/js/CommonUtil'

Vue.prototype.$CommonUtil = new CommonUtil()

// 引入boostrapcss
import 'babel-polyfill'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

/* 表示图片预览 */
import 'viewerjs/dist/viewer.css'

Vue.use(PreviewImage)

// 引入iview的样式
import 'view-design/dist/styles/iview.css'
// 按需引入
import {
  Checkbox,
  CheckboxGroup,
  Select,
  Tabs,
  TabPane,
  Modal,
  Radio,
  Page,
  Message,
  Spin,
  Option,
  Progress,
  Carousel,
  CarouselItem,
  RadioGroup,
  InputNumber,
  Cascader,
  DatePicker,
  Collapse,
  Panel,
  Input,
  Button,
  Icon,
  Drawer,
  Upload
} from 'view-design'

let iComponent = {
  Checkbox,
  CheckboxGroup,
  Select,
  Tabs,
  TabPane,
  Modal,
  Radio,
  Page,
  Option,
  Progress,
  Carousel,
  CarouselItem,
  RadioGroup,
  InputNumber,
  Cascader,
  DatePicker,
  Collapse,
  Panel,
  Input,
  Button,
  Icon,
  Drawer,
  Upload
}
for ( let name in iComponent ) Vue.component(name, iComponent[name])
Vue.prototype.$Message = mixinMessage
Vue.prototype.$Modal = Modal
Vue.prototype.$Spin = Spin

// 导入自定义全局组件
import './packages/main.js'
// 引入自定义指令
import './directive/main'
// 引入自定义拦截器
import './filters/main'
// 导入vuex仓库
import store from './store'

/* 环信登录 */
// const userInfo = localStorage.getItem('userInfo')
// if ( userInfo ) {
//   const { userId: user, accessToken } = JSON.parse(userInfo),
//     { apiURL: apiUrl, appkey: appKey } = WebIM.config,
//     options = { apiUrl, user, accessToken, appKey }
//   WebIM.conn.open(options)
// }

// 设置全局导航守卫
router.beforeEach((to, from, next) => {

  // 获取当前跳转的路由
  let arrTemp = to.path.split('/')
  let nowRouter = arrTemp[arrTemp.length - 1]

  // 设置首页定位
  if ( nowRouter === 'homePage' ) store.dispatch('_headerNav', nowRouter)
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  // WebIM,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js